import { Chip } from "@mui/material";

interface Props {
  needsReauth: boolean;
}

export default function ReauthStateChip({ needsReauth }: Props) {
  return (
    <Chip
      label={needsReauth ? "Needs reauth" : "OK"}
      size="small"
      sx={{
        bgcolor: needsReauth ? "#F79E1B40" : "#4BA66340",
        color: needsReauth ? "#F79E1B" : "#16A34A",
        fontWeight: 600,
        minWidth: 110,
      }}
    />
  );
}
